export class GetInfoPage {
	static readonly type = '[Info Page] Get';
	constructor(public readonly name: string) {}
}

export class GetInfoPageSuccess {
	static readonly type = '[Info Page] Get Section Success';
	constructor(public readonly infoPage: any) {}
}
